import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class DigitalBJTAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVon = 1.6;
		this.normVoff = 1.1;
		this.normIc = 1.45;

		this.rankVon = 0;
		this.rankVoff = 0;
		this.rankIc = 0;

		this.weightVon = 0.2;
		this.weightVoff = 0.2;
		this.weightIc = 0.1;

		this.rVon = 0;
		this.rVoff = 0;
		this.rIc = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log('partNumber,part_Von,rVon,rankVon,part_Voff,rVoff,rankVoff,part_Ic,rIc,rankIc,feRank');
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);
		// ---------------------------------------------Input voltage ON  Vi(on) Min (V)---------------------------------------------

		[this.rankVon, this.rVon] = this.calculateRankSingleSliderLTE(CIDS.V_I_ON_MIN, product, this.normVon);

		// ---------------------------------------------Input voltage OFF  Vi(off) Max (V)---------------------------------------------

		[this.rankVoff, this.rVoff] = this.calculateRankSingleSliderGTE(CIDS.V_I_OFF_MAX, product, this.normVoff);

		// ---------------------------------------------Collector current  IC Continuous (A)---------------------------------------------

		[this.rankIc, this.rIc] = this.calculateRankSingleSliderGTE(CIDS.CONTINUES_COLLECTOR_CURRENT, product, this.normIc);

		// -------------------------------------------------------------------------------------------

		let feRank = this.weightVon * this.rankVon + this.weightVoff * this.rankVoff + this.weightIc * this.rankIc;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightVon - this.weightVoff - this.weightIc) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
